import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { evaluatedUserIdSelector, setPercentiles, testIdSelector } from '../store'
import { useNotification } from 'lib/context/notification.context'
import { fetchPercentiles } from '../services/fetch-percentiles.service'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

const usePercentiles = () => {
  const dispatch = useDispatch()
  const testId = useSelector(testIdSelector)
  const userId = useSelector(evaluatedUserIdSelector)
  const state: any = useLocation().state
  const selectedId = state && typeof state === 'object' ? state.userTestId : undefined
  const selectedUserId = state?.userId || userId
  const selectedTestId = state?.testId || testId
  const { getError } = useNotification()

  const getPercentiles = useCallback(() => {
    fetchPercentiles(selectedUserId, selectedTestId, selectedId)
      .then((percentile) => {
        dispatch(setPercentiles(percentile))
      })
      .catch(() => {
        getError('Error al obtener los percentiles')
      })
  }, [dispatch, getError, selectedUserId, selectedTestId, selectedId])

  return {
    getPercentiles,
  }
}

export default usePercentiles
